import React from 'react';
import { Flex, Heading, Text, Box } from 'pounceV2';
import withSEO from 'Hoc/withSEO';
import { LinkButtonV3 } from 'Components/buttons/LinkButton';
import { Permission } from 'Generated/schema';
import useCheckPermissions from 'Hooks/useCheckPermissions';
import WarningImg from 'Assets/illustrations/warning.svg';
import { useTheme } from '@mui/material';

const Page422V3: React.FC = () => {
  const {
    palette: { tokens },
  } = useTheme();
  const canUserAccessSummary = useCheckPermissions(Permission.SummaryRead);

  return (
    <Flex justify="center" align="center" direction="column">
      <Box mb={10}>
        <img alt="Page crash illustration" src={WarningImg} width="auto" height={350} />
      </Box>
      <Heading variant="h2" fontWeight="medium" mb={2}>
        Some requests could not be processed
      </Heading>
      <Text textAlign="center" color={tokens.content.text.neutral[2]} mb={10} maxWidth={600}>
        One or more of the requests that reached our API servers contained unexpected field and
        could not be processed. Our team has been notified and will be issuing a fix.
      </Text>
      {canUserAccessSummary && <LinkButtonV3 to="/">Back to somewhere stable</LinkButtonV3>}
    </Flex>
  );
};

export default withSEO({ title: 'Unprocessable Content' })(Page422V3);
